interface PdfViewerProps {
  blobUrl: string | null;
  error: string | null;
}

export const PdfViewer = ({ blobUrl, error }: PdfViewerProps) => (
  <div className="rounded border">
    {error && (
      <div className="flex h-64 items-center justify-center">
        <span className="text-sm text-red-500">{error}</span>
      </div>
    )}

    {!error && blobUrl && (
      <embed
        src={blobUrl}
        type="application/pdf"
        className="h-96 w-full max-w-[calc(95vw-2rem)] rounded"
        title="PDF Preview"
      />
    )}
  </div>
);
